import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../fetchData";
import axios from "axios";

export const useGetLmsBoards = (filter) => {
  return useQuery({
    queryKey: ["lms/boards", filter],
    queryFn: () => fetchData(`lms/boards`, filter),

  });
};

export const useGetLmsGrades = (filter) => {
  return useQuery({
    queryKey: ["lms/grades", filter],
    queryFn: () => fetchData(`lms/grades`, filter),

  });
};

export const useGetLmsPublications = (filter) => {
  return useQuery({
    queryKey: ["lms/publications", filter],
    queryFn: () => fetchData(`lms/publications`, filter),

  });
};


export const useGetSessionListByCourseId = (course_id) => {
  return useQuery({
    queryKey: ["lms/course/sessions"],
    queryFn: () => fetchData(`lms/course/${course_id}/sessions`),

  });
};

export const useGetLmsLangauge = (filter) => {
  return useQuery({
    queryKey: ["lms/languages", filter],
    queryFn: () => fetchData(`lms/languages`, filter),
  });
};


export const useGetAllLmsCourses = (filter) => {
  return useQuery({
    queryKey: ["lms/courses", filter],
    queryFn: () => fetchData(`lms/courses`, filter),

  });
}


//api/lms/displayCourses
export const useGetAllLmsCoursesName = (filter) => {
  return useQuery({
    queryKey: ["lms/displayCourses", filter],
    queryFn: () => fetchData(`lms/displayCourses`, filter),

  });
}








export const useGetAddedCourseLms = (filters) => {
  return useQuery({
    queryKey: ["lms/displayCourses", filters],
    queryFn: () => fetchData(`lms/displayCourses`, filters),

  });
};



//api/lms/course/three-d
export const useGetAddedCourseLmsThreejs = (filters) => {
  return useQuery({
    queryKey: ["/lms/course/three-d", filters],
    queryFn: () => fetchData(`/lms/course/three-d`, filters),

  });
};


export const useGetLmsFullContentById = (id) => {
  return useQuery({
    queryKey: ["lms/full-content", id],
    queryFn: () => fetchData(`lms/${id}/full-content`),
    enabled: !!id,

  });
};

export const useGetLmsUpdateContentById = (id) => {
  return useQuery({
    queryKey: ["lms/update-content", id],
    queryFn: () => fetchData(`lms/${id}/update-content`),
    enabled: !!id,

  });
};

export const useGetLmsQuestionAnswer= (id) => {
  return useQuery({
    queryKey: ["lms/question/answer", id],
    queryFn: () => fetchData(`lms/question/answer/${id}`),
    enabled: !!id,

  });
};





export const useGetAllTickets = (filters) => {
  return useQuery({
    queryKey: ["tickets", filters],
    queryFn: () => fetchData("tickets", filters),

  });
};


export const useGetAllTrainerList = (filters) => {
  return useQuery({
    queryKey: ["trainer-assign/trainers", filters],
    queryFn: () => fetchData("trainer-assign/trainers", filters),

  });
};

export const useGetAllCoursesByTrainerId = (id) => {
  return useQuery({
    queryKey: ["trainer-assign/courses", id],
    queryFn: () => fetchData(`trainer-assign/${id}/courses`),
    enabled: !!id,

  });
};




export const useGetAllApartmentsByTrainerIdCourseId = (id, filters) => {
  return useQuery({
    queryKey: ["trainer-assign/apartments", id, filters],
    queryFn: () => fetchData(`trainer-assign/${id}/apartments`, filters),
    enabled: !!id && !!filters?.course_id,
  });
};


export const useGetAllBatchByTrainerIdCourseId = (id, filters) => {
  return useQuery({
    queryKey: ["trainer-assign/batches", id, filters],
    queryFn: () => fetchData(`trainer-assign/${id}/batches`, filters),
    enabled: !!id,
  });
};



export const useGetAssesmentCourses = () => {
  return useQuery({
    queryKey: ["trail-class"],
    queryFn: () => fetchData(`trail-class`),

  });
};


export const useGetLmsSubject = (filter) => {
  return useQuery({
    queryKey: ["subject", filter],
    queryFn: () => fetchData(`subject`, filter),

  });
};


export const useGetLmsTags = (filter) => {
  return useQuery({
    queryKey: ["tags/all", filter],
    queryFn: () => fetchData(`tags/all`, filter),

  });
};


export const useGetDocumentName = (filter) => {
  return useQuery({
    queryKey: ["Document", filter],
    queryFn: () => fetchData(`v1/document`, filter),
  });
};


export const useGetLmsChapters = (filter) => {
  return useQuery({
    queryKey: ["chapters", filter],
    queryFn: () => fetchData(`chapters`, filter),

  });
};

export const useGetLmsTopics = (filter) => {
  return useQuery({
    queryKey: ["topics", filter],
    queryFn: () => fetchData(`topics`, filter),

  });
};

export const useAllVoiceGet = (filter) => {
  return useQuery({
    queryKey: ["lms/displayCourses", filter],
    queryFn: () => fetchData(`lms/displayCourses`, filter),

  });
};

export const useAllThreejsView = (filter, options = {}) => {
  return useQuery({
    queryKey: ["threejs", filter],
    queryFn: () => fetchData(`voice/${filter}`),
    enabled: !!filter,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};

export const useGetCourses = (params = {}) => {
  return useQuery({
    queryKey: ["courses", params],
    queryFn: () =>
      fetchData("v1/lms/activity/course/selecting", params),
  });
};


export const useGetAllActivityLms = (params = {}) => {
  return useQuery({
    queryKey: ["activitylms", params],
    queryFn: () =>
      fetchData("v1/lms/activity/display/course", params),
  });
};

export const useGetActivityLmsById = (
  params = {
    gradeId:"",
    courseId: "",
    search: ""
  }
) => {
  return useQuery({
    queryKey: ["activitiesLms", params],
    queryFn: () =>
      fetchData("v1/lms/activity", params),
  });

};


export const useGetAiLms = (
  params = {
    topic: "",
    subject: "",
    grade:""
  },
  options = {}
) => {
  return useQuery({
    queryKey: ["ai-lms", params],
    queryFn: () =>
      fetchData("v1/ai-lms", params),
    ...options
  });
};


export const useGetVersionContent = (lmsId, options = {}) => {
  return useQuery({
    queryKey: ["ai-lms-version", lmsId],
    queryFn: () =>
      fetchData(`v1/ai-lms/${lmsId}`),
    ...options
  });
};

export const useAllThreejsViewFilter = (courseId, options = {}) => {
  return useQuery({
    queryKey: ["/lms/course/three-d", courseId],
    queryFn: () => fetchData(`/lms/course/three-d`, { course_id: courseId }),
    ...options,
  });
};


